var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v("SMS Managment")]),_c('data-table',{attrs:{"data-source":_vm.smsOrdred,"headers":_vm.headers,"table-class":"table-striped table-hover"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }